// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1BH_v","col":"styles_col__2oPAM"};